import axios from './axios-instance'

export default {
  all ({ q = '', page = 1, limit = 20 }) {
    return axios.get(`v1/admin/training_library?limit=${limit}&page=${page}&q=${q}`)
  },
  createOrUpdate (payload) {
    if (!payload.id) {
      return axios.post(`v1/admin/training_library`, payload)
    } else {
      return axios.put(`v1/admin/training_library/${payload.id}`, payload)
    }
  },
  destroy (id) {
    return axios.delete(`v1/admin/training_library/${id}`)
  }
}
